<template>
  <div class="management">
    <v-container class="my-5">
      <v-layout row wrap class="pa-3">
        <!-- TODO: It seems impossible to translate the pagination yet -->
        <v-data-table
          style="min-width:100%;"
          :headers="headers"
          :items="items"
          :sort-by="sort"
          :search="search"
          :loading="!initialized"
          :locale="$i18n.locale"
          :loading-text="$t('app.general.loading')"
          :no-data-text="$t('app.forms.no-data')"
          :no-results-text="$t('app.forms.no-results')"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>{{ title }}</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-text-field
                v-model="search"
                append-icon="search"
                :label="$t('app.forms.search')"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn
                v-if="canCreate"
                color="primary"
                dark
                @click.prevent="navigateTo(createRoute)"
              >
                {{ $t("app.buttons.create") }}
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template #activator="{ on }">
                <v-icon
                  small
                  class="mr-2"
                  v-on="on"
                  @click.prevent="navigateTo(inspectRoute + item.id)"
                >
                  visibility
                </v-icon>
              </template>
              <span>{{ $t("app.forms.inspect") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      default: () => []
    },
    canCreate: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    sort: {
      type: String,
      default: null
    },
    inspectRoute: {
      type: String,
      default: null
    },
    createRoute: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      search: "",
      headers: [],
      items: [],
      initialized: false
    };
  },
  watch: {
    data: function(val) {
      if (!this.loading && !this.initialized && val.length !== 0) {
        this.initialize();
      }
    }
  },
  methods: {
    initialize() {
      this.fields.forEach(field => {
        this.headers.push({
          value: field.name,
          text: field.text,
          sortable: field.sortable
        });
      });
      this.headers[0].align = "left";
      this.addGenericFields();
    },
    addGenericFields() {
      var self = this;
      this.headers.push(
        {
          value: "creation",
          text: this.$t("app.forms.fields.creation"),
          sortable: true
        },
        {
          value: "modification",
          text: this.$t("app.forms.fields.modification"),
          sortable: true
        },
        {
          value: "deletion",
          text: this.$t("app.forms.fields.deletion"),
          sortable: true
        },
        {
          value: "actions",
          text: self.$t("app.forms.actions"),
          sortable: false
        }
      );
      this.items = JSON.parse(JSON.stringify(this.data));
      this.initialized = true;
    },
    navigateTo: function(path) {
      this.$router.push(path);
    }
  }
};
</script>
